<template>
  <b-modal
    id="modal-detail-area"
    style="width: min-content; padding: 10px"
    hide-footer
    centered
    @hidden="resetModal"
    :noCloseOnBackdrop="false"
    :noCloseOnEsc="false"
    :hideHeaderClose="false"
    size="lg"
  >
    <div>
      <div class="d-flex">
        <h1 class="title-modal-area mr-5">
          <img
            class="mr-2"
            src="@/assets/images/icons/record-circle-line.png"
            alt=""
          />
          <strong>{{ title }}</strong>
        </h1>
        <div class="content-person-detail">
          <div class="content-person-detail-title">Personas expuestas</div>
          <div class="content-person-detail-value">{{ dataDetailArea?.total }}</div>
        </div>
      </div>
      <b-overlay :show="loadingDetailArea" rounded="sm">
        <template #overlay>
          <OverlayButton clase="overlay-md"> </OverlayButton>
        </template>
        <div class="mt-5">
          <div id="">
            <div class="">
              <b-table
                small
                sticky-header
                no-border-collapse
                responsive
                :busy="loadingDetailArea"
                :fields="fields"
                :items="dataDetailArea?.data"
                head-variant="light"
                class="col-12 mt-2 table-views"
                show-empty
              >
                <template #table-busy>
                  <div class="text-center my-2 mb-3">
                    <OverlayButton></OverlayButton>
                  </div>
                </template>
                <template #cell(cargo)="data"> {{ data.item?.position?.name }} </template>
                <template #empty>
                  <div class="text-center my-2">
                    <h2>Sin datos para mostrar</h2>
                  </div>
                </template>
              </b-table>
            </div>
            <div
              class="col-12 cont-pagination my-0 d-flex justify-content-center"
            >
              <Pagination
                :data="dataDetailArea"
                :limit="10"
                @pagination-change-page="loadRowsPag"
              ></Pagination>
            </div>
          </div>
          <div class="mt-4 d-flex justify-content-center">
            <button
              class="button_primary"
              @click.prevent="$bvModal.hide('modal-detail-area')"
            >
              Entendido
            </button>
          </div>
        </div>
      </b-overlay>
    </div>
  </b-modal>
</template>

<script>
import { getKinney } from "@/services/health-tracker/matrizIper/service";
import OverlayButton from "@/components/core/overlay/overlay-button.vue";
import Pagination from "laravel-vue-pagination";
export default {
  components: { OverlayButton, Pagination },
  props: {
    title: {
      type: String,
      default: "",
    },
    dataDetailArea: {
      type: Object,
      default: () => {},
    },
    loadingDetailArea: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      isLoading: false,
      data: null,
      isOpen: false,
      fields: [
        {
          key: "name",
          label: "Nombre / C.C",
          sortable: false,
        },
        {
          key: "cargo",
          label: "Cargo",
          sortable: false,
        },
        {
          key: "cc",
          label: "Identificación",
          sortable: false,
        },
      ],
    };
  },
  methods: {
    async loadKinney() {
      const me = this;
      me.isLoading = true;
      try {
        const { data } = await getKinney();
        me.data = data;
      } catch (error) {
        console.log(error);
      } finally {
        me.isLoading = false;
      }
    },
    resetModal() {
      const me = this;
      me.formData = {
        name: "",
      };
    },
    loadRowsPag(page = 1) {
      const me = this;
      me.$emit("loadRowsPag", page);
    },
  },
  mounted() {
    // const me = this;
    // me.loadKinney();
  },
};
</script>
<style lang="scss">
.button_primary {
  display: flex;
  align-items: center;
  background-color: #5d5fef;
  height: 40px;
  border-radius: 8px;
  font-size: 18px;
  gap: 10px;
  border: none;
  color: white;
  padding: 15px;
}
.title-modal-area {
  font-size: 18px;
}
.content-person-detail {
  border: 1px solid #8deaff;
  border-radius: 8px;
  padding: 8px;
  display: flex;
  flex-direction: column;
  height: 60px;
  justify-content: center;
  align-items: center;
}
.content-person-detail .content-person-detail-title {
  background-color: #004bd1;
  color: white;
  border-radius: 4px;
  padding: 3px;
  font-size: 12px;
}
.content-person-detail .content-person-detail-value {
  font-size: 18px;
  font-weight: 700;
  color: #004bd1;
}
</style>
